const dict = {
  "nav_group_overview": "Overview",
  "nav_group_sales": "Sales",
  "nav_group_customers": "Customers",
  "nav_group_service": "Service & Quality",
  "nav_group_contracts": "Contracts",
  "nav_group_operations": "Operations",
  "nav_group_purchasing": "Purchasing",
  "nav_sub_suppliers": "Suppliers",
  "nav_sub_procurement": "Procurement",
  "nav_sub_quality": "Quality",
  "nav_sub_analytics": "Analytics & Savings",
  "nav_sub_governance": "Governance & Systems",
  "suppliers": "Suppliers",
  "supplier_contacts": "Supplier Contacts",
  "supplier_contacts_sub": "Manage your suppliers' contact persons",
  "confirm_save_title": "Save changes",
  "confirm_save_changes": "Do you really want to save the changes?",
  "delete_contact": "Delete contact",
  "confirm_delete_contact": "Do you really want to delete this contact? This cannot be undone.",
  "contact_deleted": "Contact deleted",
  "supplier_documents": "Document deadlines",
  "purchase_requisitions": "Purchase requisitions",
  "purchase_orders": "Purchase orders",
  "invoice_exceptions": "Invoice exceptions",
  "supplier_complaints": "Complaints (8D)",
  "supplier_portal_admin": "Supplier Portal Access",
  "spend_analytics": "Spend analytics",
  "price_variance": "Price variance",
  "scorecards": "Scorecards",
  "consignment": "Consignment",
  "savings": "Savings pipeline",
  "ai_governance": "AI governance",
  "erp_monitor": "ERP monitor",
  "nav_group_insights": "Insights",
  "nav_group_ki": "AI",
  "ki_menu": "AI Menu",
  "ki_costs": "AI Costs",
  "quote_comparison": "AI Quote Comparison",
  "line_type": "Line type",
  "product_family": "Product family",
  "unit": "Unit",
  "sourcing": "Production",
  "sourcing_internal": "Internal (own plant)",
  "sourcing_external": "External / subcontracted",
  "select_plant": "Select plant",
  "subcontractor": "Subcontractor",
  "subcontractor_cost": "Subcontractor cost (internal)",
  "extended_price": "Extended price",
  "duplicate": "Duplicate",
  "specifications": "Specifications",
  "pm_flat": "flat",
  "no_line_items": "No line items yet — add a product or service line.",
  "generate_quote": "Generate quote",
  "quote_created": "Quote created",
  "lt_product": "Product",
  "lt_artwork": "Artwork/Prepress Setup",
  "lt_tooling": "Tooling/Die Setup",
  "lt_storage": "Storage/Warehousing (VMI)",
  "lt_freight": "Freight/Logistics",
  "lt_sample": "Sample/Trial Run",
  "lt_other": "Other",
  "pf_labels": "Roll/Pressure-Sensitive Labels",
  "pf_cartons": "Folding Cartons",
  "pf_flexible": "Flexible Packaging (Pouches/Film)",
  "pf_other": "Other",
  "spec_facestock": "Facestock / material",
  "spec_adhesive": "Adhesive",
  "spec_liner": "Liner",
  "spec_print_process": "Print process",
  "spec_finish": "Finish (varnish, foil…)",
  "spec_die_shape": "Die shape",
  "spec_board_type": "Board type",
  "spec_caliper": "Caliper",
  "spec_flute": "Flute",
  "spec_coating": "Coating / lamination",
  "spec_die_cut": "Die-cut structure",
  "spec_folding_pattern": "Folding / gluing pattern",
  "spec_units_per_case": "Units per case",
  "spec_film_structure": "Film structure",
  "spec_pouch_format": "Pouch format",
  "spec_closure": "Closure type",
  "spec_barrier": "Barrier requirements",
  "spec_generic": "Specifications",
  "rfq_documents": "Request documents (RFQ)",
  "rfq_upload": "Upload",
  "rfq_paste_email": "Paste e-mail",
  "rfq_paste_ph": "Paste the RFQ e-mail body here…",
  "rfq_no_docs": "No RFQ documents yet — upload a file or paste an e-mail.",
  "rfq_upload_hint": "PDF, DOCX, XLSX, images (scanned RFQs), .eml/.msg or pasted e-mail. Kept permanently for documentation.",
  "rfq_extract": "Extract with AI",
  "rfq_extracting": "Extracting…",
  "rfq_review_title": "Review AI-extracted items",
  "rfq_review_desc": "Review and select the proposed line items before adding them",
  "rfq_add_selected": "Add selected to line items",
  "rfq_none_selected": "Select at least one item",
  "rfq_added": "Line items added — review and save",
  "rfq_no_extract": "The AI found no line items — please enter them manually.",
  "rfq_confirm_delete": "Delete this document?",
  "rfq_meta_company": "Company",
  "rfq_meta_contact": "Contact",
  "rfq_meta_delivery": "Requested delivery",
  "rfq_meta_target": "Target price / budget",
  "pipeline_by_family": "Pipeline by product family",
  "external_sourcing_share": "External sourcing share",
  "external_sourcing_help": "Share of quoted line-item value produced externally (subcontracted).",
  "my_access": "My rights",
  "my_accounts_rights": "My accounts & rights",
  "my_role": "Role / profile",
  "visible_accounts": "Visible accounts",
  "all_accounts_visible": "You can see all accounts",
  "active_grants": "Active temporary grants",
  "no_grants": "No temporary grants",
  "access_scope": "Access scope",
  "field_permissions": "Field permissions",
  "roles_rights": "Roles & rights",
  "reassign": "Reassign",
  "responsible_reps": "Responsible sales reps",
  "assignment_history": "Assignment history",
  "changed_by": "Changed by",
  "effective_date": "Effective date",
  "bulk_assign": "Bulk assign",
  "add_grant": "Add grant",
  "grant_type": "Type",
  "deputy": "Deputy",
  "exception": "Exception",
  "valid_from": "Valid from",
  "valid_to": "Valid to",
  "reason": "Reason",
  "access_log": "Access log",
  "access_deputy": "Access & deputy",
  "restricted_account": "Restricted — basic data only",
  "restricted_hint": "You are not assigned to this account. Commercial data is hidden.",
  "role_profile": "Role profile",
  "account_visibility": "Account visibility",
  "vis_all": "All accounts",
  "vis_assigned": "Only assigned",
  "vis_team": "Assigned + team",
  "unassigned_view": "Non-assigned accounts",
  "unassigned_hidden": "Hidden",
  "unassigned_basic": "Basic data only",
  "see_revenue_qty": "Revenue / quantity",
  "see_wallet": "Wallet share & competition",
  "see_visit_notes": "Visit notes",
  "see_web_research": "External research",
  "see_ai_analysis": "Account analysis (AI)",
  "can_reassign": "May reassign accounts",
  "grants_deputy_help": "Temporary access to another rep's accounts (e.g. vacation cover). Expires automatically.",
  "manager": "Reports to (team lead)",
  "key_accounts": "Strategic key accounts",
  "no_access": "No access",
  "mode_replace": "Replace",
  "mode_add": "Add to existing",
  "select_accounts": "Select accounts",
  "user": "User",
  "dashboard": "Dashboard",
  "accounts": "Accounts",
  "contacts": "Contacts",
  "leads": "Leads",
  "opportunities": "Opportunities",
  "quotes": "Quotes",
  "complaints": "Complaints",
  "admin": "Admin",
  "admin_settings": "Settings",
  "search_placeholder": "Search accounts, contacts, opportunities…",
  "new": "New",
  "logout": "Sign out",
  "notifications": "Notifications",
  "mark_all_read": "Mark all read",
  "no_notifications": "No notifications",
  "save": "Save",
  "cancel": "Cancel",
  "delete": "Delete",
  "edit": "Edit",
  "create": "Create",
  "close": "Close",
  "export_csv": "Export CSV",
  "import_csv": "Import CSV",
  "records": "records",
  "actions": "Actions",
  "name": "Name",
  "company": "Company",
  "account": "Account",
  "owner": "Owner",
  "status": "Status",
  "stage": "Stage",
  "amount": "Amount",
  "probability": "Probability",
  "segment": "Segment",
  "segments": "Segments",
  "add": "Add",
  "segments_help": "Maintain the segment list used for customers and plants. Renaming updates all assigned records.",
  "segment_name": "Segment name",
  "segment_renamed": "Segment renamed ✓",
  "segment_deleted": "Segment deleted ✓",
  "type": "Type",
  "email": "E-mail",
  "phone": "Phone",
  "mobile": "Mobile",
  "title_field": "Title",
  "department": "Department",
  "buying_role": "Buying center role",
  "source": "Source",
  "score": "Score",
  "severity": "Severity",
  "defect_category": "Defect category",
  "claimed_value": "Claimed value",
  "date_received": "Date received",
  "sla": "SLA",
  "overdue": "Overdue",
  "convert": "Convert",
  "converted": "Converted",
  "product_type": "Product type",
  "print_technology": "Printing technology",
  "substrate": "Substrate / material",
  "finishing": "Finishing",
  "business_type": "Business type",
  "competitors": "Competitors",
  "close_reason": "Reason won/lost",
  "close_date": "Expected close",
  "annual_volume": "Annual volume",
  "num_skus": "# SKUs",
  "num_colors": "# Colors",
  "abc_class": "ABC class",
  "annual_spend": "Annual label spend",
  "payment_terms": "Payment terms",
  "incoterm": "Incoterm",
  "credit_limit": "Credit limit",
  "vat_id": "VAT ID",
  "city": "City",
  "billing_address": "Billing address",
  "customer_since": "Customer since",
  "certifications": "Certifications",
  "region": "Region",
  "parent_account": "Parent account",
  "kanban": "Kanban",
  "table": "Table",
  "weighted_forecast": "Weighted forecast",
  "aging_alert": "No activity 14+ days",
  "total_pipeline": "Total pipeline",
  "weighted_pipeline": "Weighted pipeline",
  "win_rate": "Win rate",
  "avg_deal": "Avg. deal size",
  "open_opps": "Open opportunities",
  "pipeline_by_stage": "Pipeline by stage",
  "forecast_by_month": "Forecast by month",
  "forecast_by_rep": "Forecast per rep",
  "revenue_by_segment": "Revenue by segment",
  "top_opportunities": "Top 10 opportunities",
  "open_complaints": "Open complaints",
  "critical": "Critical",
  "sla_compliance": "SLA compliance",
  "avg_resolution": "Avg. resolution days",
  "pareto": "Complaints by category (Pareto)",
  "trend_12m": "Complaint trend",
  "by_severity": "Open by severity",
  "top_accounts_complaints": "Top 5 accounts by complaint value",
  "revenue_ytd": "Revenue YTD",
  "vs_py": "vs. prior year",
  "abc_distribution": "Customer ABC distribution",
  "churn_risk": "Churn risk accounts",
  "business_split": "New business vs. renewal",
  "sales_dash": "Sales",
  "quality_dash": "Quality",
  "management_dash": "Management",
  "comments": "Comments",
  "audit_trail": "Audit trail",
  "add_comment": "Add a comment…",
  "post": "Post",
  "quote_number": "Quote no.",
  "validity": "Valid until",
  "total": "Total",
  "margin": "Margin",
  "version": "Version",
  "revise": "New version",
  "download_pdf": "Download PDF",
  "line_items": "Line items",
  "material": "Material",
  "width": "Width",
  "height": "Height",
  "quantity": "Quantity",
  "unit_price": "Price/1000",
  "tooling": "Tooling",
  "cost": "Cost/1000",
  "line_total": "Line total",
  "add_line": "Add line item",
  "price_breaks": "Price breaks",
  "winding": "Winding",
  "core_size": "Core",
  "labels_per_roll": "Labels/roll",
  "d8_report": "8D Report",
  "claimed_qty": "Claimed quantity",
  "accepted_value": "Accepted value",
  "credit_note": "Credit note no.",
  "order_number": "Order no.",
  "article_number": "Article no.",
  "received_via": "Received via",
  "costs": "Complaint costs",
  "cost_credit": "Credit note",
  "cost_reprint": "Reprint",
  "cost_freight": "Freight",
  "save_costs": "Save costs",
  "complaint_new_subtitle": "SLA deadline and 8D report are created automatically.",
  "delete_file_confirm": "Delete this file?",
  "contact": "Contact",
  "new_contact": "New contact",
  "pl_help": "Each option has a stable ID (never changes, used for reporting) and a display label per language. An empty label falls back to EN or the ID. New options get a free-form ID (slug).",
  "pl_new_label": "New option (label)",
  "pl_id_exists": "This ID already exists",
  "users": "Users",
  "picklists": "Picklists",
  "role": "Role",
  "territory": "Territory",
  "password": "Password",
  "add_user": "Add user",
  "tags": "Tags",
  "info": "Details",
  "hierarchy": "Hierarchy",
  "children_accounts": "Subsidiaries",
  "open_opp_value": "Open opp. value",
  "avg_margin": "Avg. margin",
  "estimated_volume": "Est. annual volume",
  "product_interest": "Product interest",
  "possible_duplicate": "Possible duplicate found",
  "login_title": "Sign in to Encasa",
  "login_sub": "CRM & SRM for packaging manufacturers",
  "recently_viewed": "Recently viewed",
  "no_results": "No results",
  "loading": "Loading…",
  "empty_title": "Nothing here yet",
  "empty_cta": "Create your first record to get started",
  "all_stages": "All stages",
  "all": "All",
  "required_close_reason": "Select the reason to close this deal",
  "mark_won": "Close Won",
  "mark_lost": "Close Lost",
  "quality": "Quality",
  "engagement": "Engagement (0-30)",
  "linkedin": "LinkedIn",
  "preferred_language": "Preferred language",
  "birthday": "Birthday",
  "notes": "Notes",
  "shipping_addresses": "Shipping addresses",
  "trade_fair": "Trade fair",
  "activities": "Activities",
  "calendar": "Calendar",
  "list_view": "List",
  "due_date": "Due date",
  "priority": "Priority",
  "subject": "Subject",
  "date": "Date",
  "time": "Time",
  "activity_type": "Type",
  "done": "Done",
  "open_status": "Open",
  "visit_report": "Visit report",
  "attendees": "Attendees",
  "topics": "Topics",
  "agreements": "Agreements",
  "next_steps": "Next steps",
  "description": "Description",
  "tradefair": "Trade Fair Mode",
  "quick_capture": "Quick lead capture",
  "captured_leads": "Leads captured",
  "save_next": "Save & next lead",
  "today": "Today",
  "my_only": "Only mine",
  "all_team": "Whole team",
  "mark_done": "Mark done",
  "lead_saved": "Lead saved",
  "samples": "Samples & Artwork",
  "samples_tab": "Sample orders",
  "artworks": "Artwork approvals",
  "sample_number": "Sample no.",
  "artwork_number": "Artwork no.",
  "requested_date": "Requested",
  "tracking_number": "Tracking no.",
  "upload_pdf": "Upload PDF",
  "view_pdf": "View PDF",
  "no_file": "No file yet",
  "contracts": "Contracts",
  "contract_number": "Contract no.",
  "start_date": "Start",
  "end_date": "End",
  "annual_value": "Annual value",
  "price_index": "Price index",
  "index_base_value": "Index base value",
  "indexation_threshold": "Indexation threshold %",
  "indexation_clause": "Indexation clause",
  "days_to_expiry": "Days to expiry",
  "expiring_soon": "Expiring soon",
  "expired": "Expired",
  "forecast": "Forecast & Targets",
  "target": "Target",
  "actual": "Actual",
  "attainment": "Attainment",
  "burndown": "Target vs. actual (cumulative)",
  "monthly_comparison": "Monthly target vs. actual",
  "edit_targets": "Edit targets",
  "all_reps": "All reps",
  "by_territory": "By territory",
  "site_match": "Site matching",
  "suggest_site": "Suggest production site",
  "best_press": "Best press",
  "match_missing": "Not covered",
  "plants": "Plants & Presses",
  "presses": "Presses",
  "technology": "Technology",
  "max_colors": "Max. colors",
  "web_width": "Web width (mm)",
  "add_plant": "Add plant",
  "add_press": "Add press",
  "location": "Location",
  "send_email": "Send by e-mail",
  "send_8d": "Send 8D report",
  "download_8d": "8D report PDF",
  "recipient": "Recipient",
  "message": "Message",
  "send": "Send",
  "email_sent_ok": "E-mail sent",
  "email_simulated": "E-mail simulated (SMTP not configured)",
  "photos": "Photos & files",
  "upload_photo": "Upload file",
  "portal_users": "Portal access",
  "add_portal_user": "Add portal access",
  "reports": "Reports",
  "report_name": "Report name",
  "run_report": "Run",
  "save_report": "Save report",
  "shared": "Shared with team",
  "add_filter": "Add filter",
  "field": "Field",
  "operator": "Operator",
  "value": "Value",
  "export_excel": "Export Excel",
  "my_reports": "Saved reports",
  "columns": "Columns",
  "locations": "Locations",
  "site_type": "Site type",
  "country": "Country",
  "map_view": "Map",
  "erp_number": "Local ERP no.",
  "timezone": "Timezone",
  "lat": "Latitude",
  "lng": "Longitude",
  "account_manager": "Account manager",
  "network": "Network",
  "relationships": "Relationships",
  "add_relationship": "Add relationship",
  "relationship_type": "Relationship type",
  "volume_pct": "% of volume",
  "contract_ref": "Contract ref.",
  "performance": "Performance",
  "otif": "OTIF",
  "on_time": "On time",
  "in_full": "In full",
  "fill_rate": "Fill rate",
  "lead_time": "Lead time adherence",
  "complaint_rate": "Complaints / 1000 orders",
  "forecast_accuracy": "Forecast accuracy",
  "share_of_wallet": "Share of wallet",
  "dso": "DSO (days)",
  "health_score": "Health",
  "days_late": "Days late",
  "scorecard": "Customer scorecard",
  "export_pdf": "Export PDF",
  "duplicates": "Duplicates",
  "merge": "Merge",
  "link_as_network": "Link as network",
  "confidence": "Confidence",
  "pick_survivor": "Choose surviving record",
  "merged_ok": "Records merged",
  "user_location_matrix": "User–Location matrix",
  "weekly_digest": "Weekly digest",
  "send_test": "Send test to…",
  "send_now": "Send to all reps now",
  "digest_enabled": "Automatic dispatch Mondays 07:00",
  "preview": "Preview",
  "perm_groups": "Permission groups",
  "add_group": "Add group",
  "module_rights": "Module rights",
  "default_right": "Default right",
  "margins_visible": "Margins visible",
  "scoped_label": "Location-scoped visibility",
  "orders_12m": "Orders (12m)",
  "no_kpi_data": "No order history for this account yet",
  "qbr_package": "QBR package (PDF)",
  "current_indexes": "Current index values",
  "index_deviation": "Δ Index",
  "index_alerts": "index alerts triggered",
  "renew": "Renew",
  "renew_contract": "Renew contract",
  "renewed_from": "Renewed from",
  "duration_months": "Duration (months)",
  "new_start_date": "New start",
  "new_end_date": "New end",
  "contract_renewed": "Contract renewed",
  "import_indexes": "Import indexes",
  "import_index_help": "Paste CSV or upload a file. Formats supported: long (date, index_name, value) or wide (date, index-A, index-B, …). Delimiter and date format are auto-detected (ISO / DE / month).",
  "paste_csv": "Paste CSV data",
  "upload_file": "Upload file",
  "or_upload": "or upload file",
  "target_index": "Target index (only for single-value files)",
  "any_column": "Auto-detect",
  "import_result": "Imported",
  "rows_skipped": "skipped",
  "index_history": "Index history",
  "index_trend": "Price index trend",
  "no_history_yet": "No history yet – edit or import values",
  "last_12m": "12 months",
  "last_24m": "24 months",
  "last_36m": "36 months",
  "manual": "Manual entry",
  "import": "Import",
  "guide": "Guide",
  "guide_title": "Encasa CRM & SRM Guide",
  "guide_subtitle": "Everything you need to get the most out of your CRM & SRM platform — module by module.",
  "guide_intro": "Select a module below to learn what it does, or replay the guided tour.",
  "start_tour": "Start tour",
  "restart_tour": "Replay guided tour",
  "tour_skip": "Skip tour",
  "tour_next": "Next",
  "tour_back": "Back",
  "tour_finish": "Finish",
  "tour_step": "Step",
  "greeting_morning": "Good morning",
  "greeting_afternoon": "Good afternoon",
  "greeting_evening": "Good evening",
  "todays_overview": "Here is your business at a glance today.",
  "tour_welcome_title": "Welcome to Encasa CRM & SRM",
  "tour_welcome_body": "Take a quick 60-second tour of the key areas. You can replay it anytime from the Guide page.",
  "tour_nav_title": "Main navigation",
  "tour_nav_body": "Jump between all modules — accounts, opportunities, quotes, complaints, contracts and more.",
  "tour_search_title": "Global search",
  "tour_search_body": "Instantly find accounts, contacts, opportunities, quotes and complaints from anywhere.",
  "tour_new_title": "Create records fast",
  "tour_new_body": "Use the New button to add any record type without leaving the current page.",
  "tour_notif_title": "Notifications",
  "tour_notif_body": "SLA breaches, expiring contracts and approval reminders all land here.",
  "tour_done_title": "You're all set!",
  "tour_done_body": "Open the Guide page anytime for detailed help on every module.",
  "guide_desc_dashboard": "Sales, quality and management dashboards with live KPIs, pipeline, forecasts and churn risk.",
  "guide_desc_accounts": "360° customer view: hierarchy, certifications, KPIs, network relationships and QBR export.",
  "guide_desc_locations": "Manage plant/site locations with map view, region and site-type filtering.",
  "guide_desc_contacts": "Contacts with multi-account links and buying-center roles.",
  "guide_desc_leads": "Lead scoring and one-click conversion to account, contact and opportunity.",
  "guide_desc_opportunities": "Drag-&-drop Kanban pipeline, weighted forecast, aging alerts and site matching.",
  "guide_desc_quotes": "Line-item quotes with price breaks, margins, versioning and PDF export.",
  "guide_desc_complaints": "8D complaint management with SLA tracking, escalation and cost capture.",
  "guide_desc_samples": "Sample orders and artwork approvals with real PDF upload and status workflow.",
  "guide_desc_contracts": "Contracts with price-index clauses, renewal workflow and trend charts.",
  "guide_desc_activities": "Calls, meetings, visits and tasks with a shared team calendar.",
  "guide_desc_reports": "Custom report builder with filters, saved reports and Excel export.",
  "guide_desc_forecast": "Territory targets vs. actuals with attainment KPIs and burndown charts.",
  "guide_desc_tradefair": "Mobile-friendly quick lead capture for trade fairs.",
  "guide_desc_admin": "Users, permission groups, picklists, plants, duplicates and digest settings.",
  "customer_forecast": "Customer forecast",
  "select_account": "Select customer",
  "fiscal_year": "Fiscal year",
  "scope": "Scope",
  "customer_level": "Customer level (no project)",
  "all_projects": "All (aggregate)",
  "projects": "Projects",
  "project": "Project",
  "new_project": "New project",
  "add_project": "Add project",
  "project_name": "Project name",
  "link_opportunity": "Link opportunity (optional)",
  "no_opp_link": "No opportunity",
  "delete_project": "Delete project",
  "project_deleted": "Project deleted",
  "project_created": "Project created",
  "metric": "Metric",
  "revenue": "Revenue",
  "month": "Month",
  "fc_revenue": "Forecast rev.",
  "actual_revenue": "Actual rev.",
  "fc_qty": "Forecast qty",
  "actual_qty": "Actual qty",
  "total_forecast": "Total forecast",
  "total_actual": "Total actual",
  "deviation": "Deviation",
  "save_forecast": "Save",
  "forecast_saved": "Forecast saved",
  "forecast_vs_actual": "Forecast vs. Actual",
  "import_excel": "Import Excel",
  "download_template": "Template",
  "import_done": "Imported rows",
  "aggregate_readonly": "Aggregate view is read-only — pick a project or customer level to edit.",
  "guide_desc_customer_forecast": "Monthly customer & project forecast vs. actual (revenue + quantity) with Excel up/download.",
  "autofill_actuals": "Pull actuals from orders",
  "autofilled": "Actual months filled",
  "no_autofill": "No new actuals found",
  "group": "Group",
  "group_rollup": "Group overview",
  "members": "Members",
  "fillers": "Co-packers / fillers",
  "global_cs": "Global Customer Service",
  "assign_global_cs": "Assign global CS owner",
  "cs_assigned": "Global CS owner set",
  "group_complaints": "Group complaints",
  "total_members": "Members",
  "no_cs_owner": "Not assigned",
  "open_pipeline": "Open pipeline",
  "top_customer_forecast": "Top customers · Forecast vs. Actual",
  "portal_quotes": "Quotes",
  "portal_artworks": "Artwork approvals",
  "approve": "Approve",
  "reject": "Request revision",
  "decision_saved": "Decision saved",
  "add_note": "Note (optional)",
  "awaiting_decision": "Awaiting your decision",
  "no_quotes_portal": "No quotes available yet.",
  "no_artworks_portal": "No artworks to review.",
  "forecast_approvals": "Forecast approvals",
  "approval_status": "Approval",
  "submit_for_approval": "Submit for approval",
  "fc_approve": "Approve",
  "fc_reject": "Reject",
  "reject_reason": "Reason for rejection",
  "st_draft": "Draft",
  "st_submitted": "In approval",
  "st_approved": "Approved",
  "st_rejected": "Rejected",
  "st_none": "Not submitted",
  "no_pending_approvals": "No forecasts awaiting approval.",
  "submitted_by": "Submitted by",
  "pending_approval_hint": "In approval (not yet counted as committed)",
  "approved_fc": "Approved",
  "pending_fc": "In approval",
  "group_qbr": "Group QBR (PDF)",
  "submitted_ok": "Submitted for approval",
  "approved_ok": "Forecast approved",
  "rejected_ok": "Forecast rejected",
  "guide_desc_forecast_approvals": "Review, approve or reject customer forecasts submitted by the sales team.",
  "history": "History",
  "show_history": "History",
  "no_history": "No history yet.",
  "ev_submitted": "submitted",
  "ev_approved": "approved",
  "ev_rejected": "rejected",
  "send_reminders": "Send reminders now",
  "reminders_sent_msg": "Reminders sent",
  "lp_switch_normal": "Normal",
  "lp_switch_hero": "Hero Mode",
  "lp_eyebrow": "CRM & SRM for packaging manufacturers",
  "lp_title": "Sales and purchasing on one platform.",
  "lp_desc": "Customers, pipeline, quotes and quality — plus supplier management, four-eyes bank verification and procurement. One platform for packaging manufacturers: labels, shrink sleeves, flexible packaging and folding cartons.",
  "lp_cta": "Sign in to Encasa",
  "lp_f1_t": "Sales & Quotes",
  "lp_f1_d": "Track pipeline, generate PDF quotes and forecast revenue.",
  "lp_f2_t": "Purchasing & Suppliers",
  "lp_f2_d": "Supplier master data, four-eyes bank control and procurement.",
  "lp_f3_t": "Quality & KPIs",
  "lp_f3_d": "8D complaints, scorecards, forecasts and QBR reports.",
  "lp_nav_signin": "Sign in",
  "lp_features_title": "Everything for sales and purchasing",
  "lp_features_sub": "One platform covering the full commercial cycle — from lead to delivery, from supplier to invoice.",
  "lp_f4_t": "Contracts & AI",
  "lp_f4_d": "AI contract extraction, deadline tracking and price-index clauses.",
  "lp_f5_t": "Analytics & Forecasts",
  "lp_f5_d": "Live dashboards, customer forecasts and management KPIs.",
  "lp_f6_t": "Portals & Collaboration",
  "lp_f6_d": "Customer and supplier portals with secure, audited access.",
  "lp_signin_card_title": "Welcome back",
  "lp_explore": "Explore capabilities",
  "lp_stat1_l": "Customer 360°",
  "lp_stat2_l": "Languages",
  "lp_stat3_l": "Quality process",
  "lp_stat4_l": "Supplier management",
  "hero_eyebrow": "The extraordinary CRM squad",
  "hero_tagline": "Save your pipeline. Defeat the chaos.",
  "hero_desc": "Seven heroes. One mission: crush churn, smash SLAs and rescue every deal from the brink.",
  "hero_cta": "Join the Force",
  "hero_p1_t": "Pipeline Powerhouse",
  "hero_p1_d": "Blast through your sales funnel at superhuman speed.",
  "hero_p2_t": "Complaint Crusher",
  "hero_p2_d": "Neutralize quality threats before they escalate.",
  "hero_p3_t": "Forecast Vision",
  "hero_p3_d": "See the future of every customer's revenue.",
  "hero_meet": "Meet the Force",
  "visit_notes": "Visit notes",
  "vn_record": "Record note",
  "vn_recording": "Recording…",
  "vn_stop": "Stop recording",
  "vn_transcribing": "Transcribing…",
  "vn_analyzing": "Analyzing with AI…",
  "vn_transcript": "Transcript",
  "vn_edit_transcript": "Review & edit the transcript before saving (dictation of product names can be error-prone).",
  "vn_analyze_save": "Analyze & save",
  "vn_ai_summarize": "Summarize with AI",
  "vn_ai_summary_title": "AI summary (Visit-report Assistant)",
  "vn_ai_apply": "Apply",
  "vn_language": "Language",
  "vn_auto": "Auto-detect",
  "vn_manual_entry": "Type manually",
  "vn_upload_email": "Upload e-mail",
  "vn_manual_text_ph": "Type your visit note here…",
  "vn_source": "Source",
  "vn_source_voice": "Voice",
  "vn_source_email": "E-mail",
  "vn_source_manual": "Manual",
  "vn_risk": "Rating",
  "vn_risk_green": "Normal",
  "vn_risk_yellow": "Watch",
  "vn_risk_orange": "Risk",
  "vn_risk_red": "Escalation",
  "vn_partner": "Contact & role",
  "vn_topics": "Topics discussed",
  "vn_agreements": "Agreements / open points",
  "vn_competitors": "Competitors mentioned",
  "vn_pricing": "Price / terms topics",
  "vn_next_steps": "Next steps",
  "vn_triggers": "Trigger topics",
  "vn_reason": "Reason",
  "vn_override": "Correct rating",
  "vn_override_reason": "Reason for correction (required)",
  "vn_linked_opps": "Linked opportunities",
  "vn_suggested_tasks": "Suggested tasks",
  "vn_create_tasks": "Create selected tasks",
  "vn_tasks_created": "Tasks created",
  "vn_assignee": "Assignee",
  "vn_no_notes": "No visit notes yet.",
  "vn_filter_all_sources": "All sources",
  "vn_filter_all_risks": "All ratings",
  "vn_search_ph": "Search notes… (e.g. when was price last discussed)",
  "vn_from": "From",
  "vn_to": "To",
  "vn_creator": "Creator",
  "vn_all_creators": "All creators",
  "vn_saved": "Note saved",
  "vn_show_transcript": "Show transcript",
  "vn_hide_transcript": "Hide transcript",
  "vn_mic_error": "Microphone not available. Please use manual entry or e-mail upload.",
  "vn_reanalyze": "Re-analyze",
  "vn_corrected": "corrected",
  "vn_new_note": "New note",
  "vn_who": "Who",
  "vn_what": "What",
  "vn_due": "Due",
  "vn_record_hint": "Tap to dictate your note right after the meeting.",
  "vn_task_subject": "Task",
  "vn_add_task": "Add task",
  "escalation": "Escalation",
  "escalation_help": "Who receives red-risk alerts and the weekly risk digest.",
  "escalation_saved": "Recipients saved",
  "sla_rules": "SLA rules",
  "sso_tab": "Microsoft SSO",
  "sso_signin": "Sign in with Microsoft",
  "sso_help": "Single sign-on via Microsoft Entra ID (Azure AD). Only users already created in the CRM can sign in with Microsoft (matched by email).",
  "sso_enabled": "Enable Microsoft sign-in",
  "sso_tenant": "Directory (tenant) ID",
  "sso_client_id": "Application (client) ID",
  "sso_secret": "Client secret",
  "sso_secret_ph": "Enter a new secret (leave blank to keep existing)",
  "sso_domains": "Allowed email domains",
  "sso_domains_help": "Comma-separated, e.g. yourcompany.com, subsidiary.com. Empty = no domain restriction.",
  "sso_callback": "Redirect URI (register in Azure)",
  "sso_callback_help": "Add exactly this URI in your Azure app registration under Authentication → Web.",
  "sso_saved": "SSO settings saved",
  "sla_saved": "SLA rules saved",
  "saving": "Saving…",
  "hours": "hours",
  "days": "days",
  "sla_help": "Configure the service-level thresholds that drive automatic reminders and escalations across the CRM.",
  "sla_complaint_ack_hours": "Complaint acknowledgement",
  "sla_complaint_ack_hours_desc": "Hours until a new complaint is escalated to managers if not acknowledged.",
  "sla_artwork_reminder_days": "Artwork approval reminder",
  "sla_artwork_reminder_days_desc": "Days a sent artwork may await customer approval before reminding the owner.",
  "sla_contract_renewal_days": "Contract renewal window",
  "sla_contract_renewal_days_desc": "Days before a contract expires when renewal reminders start.",
  "orgchart_tab": "Org chart",
  "orgchart_title": "Buying center map",
  "orgchart_subtitle": "Contacts arranged by decision-making influence.",
  "orgchart_tier_decision": "Decision",
  "orgchart_tier_influence": "Influence & advocacy",
  "orgchart_tier_operational": "Operational / access",
  "orgchart_tier_empty": "No contacts in this tier",
  "orgchart_no_role": "Unassigned role",
  "orgchart_empty": "No contacts yet — add contacts to see the buying center map.",
  "orgchart_show_all": "Show all",
  "role_decision_maker": "Decision Maker",
  "role_champion": "Champion",
  "role_influencer": "Influencer",
  "role_gatekeeper": "Gatekeeper",
  "role_user": "User",
  "guide_desc_visit_notes": "AI visit notes: dictate or upload e-mails, get structured summaries and a 4-level risk rating.",
  "ai_contract_analysis": "AI contract analysis",
  "contract_summary": "Summary",
  "contract_deviations": "Deviations vs. CRM data",
  "no_deviations": "No deviations detected.",
  "contract_value": "Contract value",
  "crm_value": "CRM value",
  "deviation_match": "Match",
  "deviation_deviation": "Deviation",
  "deviation_unknown": "Unknown",
  "severity_critical": "Critical",
  "severity_warning": "Warning",
  "severity_info": "Info",
  "extracted_terms": "Extracted terms",
  "contract_parties": "Parties",
  "contract_term": "Term",
  "notice_period": "Notice period",
  "auto_renewal": "Auto-renewal",
  "pricing_conditions": "Pricing & conditions",
  "volume_minimum": "Volume / minimum purchase",
  "liability_warranty": "Liability & warranty",
  "price_index_clauses": "Price index clauses",
  "upload_contract_doc": "Upload contract (PDF/DOCX)",
  "analyzing": "Analyzing…",
  "analyzing_hint": "Extracting terms with AI — this can take up to 30 seconds.",
  "only_pdf_docx": "PDF or DOCX only",
  "no_contract_docs": "No contract documents uploaded yet.",
  "deviations_short": "deviations",
  "ok": "OK",
  "pages": "pages",
  "paragraphs": "paragraphs",
  "ref_page": "p.",
  "ref_paragraph": "para.",
  "months": "months",
  "yes": "Yes",
  "no": "No",
  "extraction_done": "AI extraction complete",
  "extraction_failed": "AI extraction failed",
  "confirm_delete_doc": "Delete this document?",
  "deleted": "Deleted",
  "view_original": "View original",
  "reextract": "Re-analyze",
  "back": "Back",
  "contract_deadlines": "Contract deadlines",
  "contract_deadlines_subtitle": "Notice periods, renewals and expiry — driven by AI-extracted terms.",
  "refresh": "Refresh",
  "urgency": "Urgency",
  "urgency_notice_missed": "Notice missed",
  "urgency_notice_soon": "Notice due soon",
  "urgency_expired": "Expired",
  "urgency_expiring_soon": "Expiring soon",
  "urgency_none": "OK",
  "notice_deadline": "Notice deadline",
  "with_ai_analysis": "With AI analysis",
  "no_deadlines": "No open contracts.",
  "no_notice_detected": "No notice period detected",
  "upload_for_notice": "Upload contract",
  "contract_data": "Contract data",
  "documents": "Documents",
  "account_analysis": "Account analysis",
  "ai_analysis": "AI account analysis",
  "wallet_share_tab": "Plant & Wallet share",
  "last_generated": "Last generated",
  "generate_now": "Generate now",
  "update_now": "Update now",
  "ai_never_run": "No analysis generated yet.",
  "generating": "Generating analysis…",
  "ai_trend": "Trend development",
  "ai_sentiment": "Sentiment over time",
  "ai_stakeholders": "Stakeholder power analysis",
  "ai_wallet": "Wallet-share development",
  "ai_risks_opps": "Risk factors & opportunities",
  "ai_recommendations": "Recommendations",
  "ai_direction": "Direction",
  "dir_growing": "growing",
  "dir_stable": "stable",
  "dir_declining": "declining",
  "ai_notable_jumps": "Notable jumps",
  "ai_no_data": "No data available for this section yet.",
  "ai_role": "Role / influence",
  "ai_stance": "Stance towards us",
  "ai_flag": "Change flag",
  "risk_label": "Risk",
  "chance_label": "Opportunity",
  "priority_short": "Prio",
  "ext_research": "External research",
  "ext_research_sub": "Public sources · unverified",
  "ext_update": "Update research",
  "ext_never": "No external research yet.",
  "ext_researching": "Researching public sources…",
  "ext_news": "Company news",
  "ext_financials": "Financial situation",
  "ext_strategy": "Strategic direction",
  "ext_market_comp": "Customer's market competitors",
  "ext_contact_check": "Contact verification",
  "ext_no_info": "No relevant public information found.",
  "ext_unverified": "unverified · public source",
  "ext_source": "Source",
  "ext_no_date": "no date",
  "internal_verified": "verified · own records",
  "ws_plant_supply": "Plant → customer supply",
  "ws_add_supply": "Add supply",
  "ws_plant": "Plant",
  "ws_period": "Period",
  "ws_period_month": "Monthly",
  "ws_period_quarter": "Quarterly",
  "ws_qty": "Quantity",
  "ws_unit": "Unit",
  "ws_revenue": "Revenue (EUR)",
  "ws_wallet": "Wallet share (customer level)",
  "ws_add_wallet": "Add wallet-share entry",
  "ws_category": "Category",
  "ws_budget": "Total budget/need (EUR)",
  "ws_our_eur": "Our share (EUR)",
  "ws_our_pct": "Our share %",
  "ws_comp_pct": "Competitor share %",
  "ws_total_pct": "Total %",
  "ws_competitors": "Competitors",
  "ws_comp_name": "Competitor",
  "ws_comp_share": "Share %",
  "ws_comp_source": "Source",
  "ws_add_competitor": "Add competitor",
  "ws_over100": "Sum of shares exceeds 100% — please check.",
  "ws_stale": "Wallet-share data is older than 6 months — please update.",
  "ws_trend": "Wallet share over time",
  "ws_no_supply": "No plant supplies recorded yet.",
  "ws_no_wallet": "No wallet-share entries yet.",
  "ws_notes": "Notes / source",
  "ws_change_history": "Change history",
  "ws_saved": "Saved",
  "ws_deleted": "Deleted",
  "plant_view": "Plant view",
  "plant_view_sub": "Which customers each plant supplies",
  "pv_customers": "Customers",
  "pv_total_qty": "Total quantity",
  "pv_total_revenue": "Total revenue",
  "pv_no_data": "No supply data for this plant yet.",
  "pv_select_plant": "All plants",
  "guide_desc_plant_view": "Aggregated plant view: which customers each plant supplies and with what volume.",
  "analysis_pdf": "Analysis PDF (QBR)",
  "access_denied_intel": "Only sales, KAM and management can view this data.",
  "language": "Language",
  "lang_en": "English",
  "lang_de": "German",
  "lang_es": "Spanish",
  "lang_pt": "Portuguese",
  "lang_it": "Italian",
  "translate": "Translate",
  "translating": "Translating…",
  "show_original": "Show original",
  "translated_hint": "AI translation — technical terms (Wallet Share, OTIF, SLA…) stay in English.",
  "faq": "FAQ",
  "copy": "Copy",
  "copied": "Copied",
  "outlook_addin": "Outlook Add-in",
  "outlook_addin_title": "Outlook Add-in",
  "outlook_addin_intro": "Install the Encasa CRM add-in in Outlook to turn any email into a lead, complaint or activity with one click — directly from your inbox.",
  "outlook_addin_manifest": "Add-in manifest",
  "outlook_addin_download": "Download manifest",
  "outlook_addin_s1_t": "Download the manifest",
  "outlook_addin_s1_d": "Download the manifest file above (or copy its URL for a central deployment via your Microsoft 365 admin).",
  "outlook_addin_s2_t": "Add it to Outlook",
  "outlook_addin_s2_d": "In Outlook on the web OR classic Outlook 365 desktop (Windows) or the new Outlook: Settings/menu → 'Get Add-ins' / 'Manage add-ins' → My add-ins → 'Add a custom add-in' → 'Add from file' and select the downloaded manifest. Admins can deploy it org-wide in the Microsoft 365 admin center.",
  "outlook_addin_s3_t": "Open an email",
  "outlook_addin_s3_d": "Open any message and click the 'Add to CRM' button. Sign in once with your Encasa CRM account (the same email and password).",
  "outlook_addin_s4_t": "Push to CRM",
  "outlook_addin_s4_d": "Choose Lead, Complaint or Activity. The sender is matched to an existing customer automatically, and the new record opens in the CRM.",
  "outlook_addin_note": "The add-in reads only the currently selected message (ReadItem permission) and sends it to Encasa CRM over HTTPS. It runs in Outlook on the web, classic Outlook 365 desktop (Windows) and the new Outlook for Windows/Mac — each with a Microsoft 365 / Exchange account (not with POP/IMAP-only accounts). No Microsoft admin consent is needed for personal sideloading.",
  "faq_title": "Frequently asked questions",
  "faq_subtitle": "Quick answers to the most common questions about Encasa CRM & SRM.",
  "faq_intro": "Can't find what you need? Replay the guided tour or open a module guide above.",
  "guide_faq_card": "FAQ",
  "guide_desc_faq": "Answers to common questions about roles, contracts, forecasts, languages and AI features.",
  "guide_getting_started": "Getting started",
  "guide_gs_intro": "Four quick steps to get productive on day one.",
  "guide_gs_1_t": "1 · Find anything fast",
  "guide_gs_1_d": "Use the global search bar at the top to jump to any account, contact, opportunity, quote or complaint.",
  "guide_gs_2_t": "2 · Work your accounts",
  "guide_gs_2_d": "Open a customer for the 360° view — hierarchy, KPIs, contracts, visit notes and AI analysis in one place.",
  "guide_gs_3_t": "3 · Stay ahead of deadlines",
  "guide_gs_3_d": "The notification bell and the Contract deadlines page surface SLA breaches, renewals and notice periods.",
  "guide_gs_4_t": "4 · Work in your language",
  "guide_gs_4_d": "Switch the interface between EN/DE/ES/PT/IT anytime via the language selector in the top bar.",
  "guide_more_help": "Need more help?",
  "guide_open_faq": "Open FAQ",
  "guide_desc_my_access": "See your role, field permissions, visible accounts and active deputy grants.",
  "faq_q1": "How do roles and permissions work?",
  "faq_a1": "Each user has a role (admin, sales manager, sales rep, customer service, read-only) plus an optional permission profile. These decide which accounts you see, whether you see commercial data (revenue, margins, Wallet Share) and whether you can edit. Check your own rights on the “My rights” page.",
  "faq_q2": "I need to work on a colleague's account. How do I get access?",
  "faq_a2": "An admin or sales manager can grant you a temporary deputy access (e.g. vacation cover) or a one-off exception under Admin → Access & deputy. Grants have a start/end date and expire automatically.",
  "faq_q3": "How does the AI contract analysis work?",
  "faq_a3": "Open a contract, go to the Documents tab and upload a PDF or DOCX. GPT-4o extracts the term, notice period, auto-renewal, pricing and index clauses — each with a page/paragraph reference — and flags deviations from your CRM data. It never changes your data; it only reports.",
  "faq_q4": "What do the contract deadline urgencies mean?",
  "faq_a4": "“Notice missed” = the cancellation deadline has passed; “Notice due soon” = within 30 days; “Expiring soon” = ends within 90 days; “Expired” = end date passed. They are driven by the AI-extracted notice period, so upload the contract document to activate them.",
  "faq_q5": "How do forecasts and approvals work?",
  "faq_a5": "Enter monthly forecast vs. actual per customer and project. Reps submit a fiscal-year forecast for approval; sales managers approve or reject it in the Forecast approvals queue. Approved forecasts count as committed; editing resets it to draft for re-approval.",
  "faq_q6": "Which languages are supported and how do I switch?",
  "faq_a6": "The interface is available in English, German, Spanish, Portuguese and Italian. Use the language selector in the top bar — your choice is remembered on this device. Technical terms such as Wallet Share, OTIF, SLA and QBR intentionally stay in English.",
  "faq_q7": "Can I translate a note or summary written in another language?",
  "faq_a7": "Yes. AI-generated summaries (contract analysis, account analysis, visit notes) show a “Translate” link that renders the text in your current interface language on demand, and lets you toggle back to the original.",
  "faq_q8": "How do complaints, 8D and SLA tracking work?",
  "faq_a8": "Complaints get an auto REK number and an acknowledgement SLA. If not acknowledged in time they escalate to managers. Capture the 8D report (D1–D8) and costs, then e-mail the 8D PDF to the customer directly from the complaint.",
  "faq_q9": "How do I export data?",
  "faq_a9": "Most lists offer CSV export/import. The report builder exports to Excel (XLSX). Scorecards, QBR packages and the account analysis export to PDF from the respective screens.",
  "faq_q10": "What do the visit-note risk levels mean?",
  "faq_a10": "After you dictate or upload a note, AI classifies it as Normal (green), Watch (yellow), Risk (orange) or Escalation (red). Orange notifies the account owner; red also alerts the escalation recipients. You can correct the rating with a mandatory reason.",
  "translations_tab": "Translations",
  "tr_help": "Override any interface text per language. An empty value restores the built-in translation. Changes apply instantly for all users.",
  "tr_no_overrides": "No overrides yet — search a key above to customise a text.",
  "updated": "Updated",
  "upload": "Upload",
  "ideas_bugs": "Ideas & Bugs",
  "ib_page_desc": "Submit bugs and feature ideas for Encasa, track their status and vote to shape the roadmap.",
  "ib_report": "Report bug / idea",
  "ib_report_title": "Report a bug or idea",
  "ib_report_desc": "Help us improve Encasa. Describe the bug or the idea and add a screenshot if it helps.",
  "ib_type_bug": "Bug",
  "ib_type_idea": "Idea",
  "ib_type_feature_request": "Feature Request",
  "ib_title_field": "Title",
  "ib_title_ph": "Short, descriptive summary",
  "ib_description": "Description",
  "ib_description_ph": "What happened / what would you like? Paste a screenshot directly here.",
  "ib_module_area": "Module / area",
  "ib_submit": "Submit",
  "ib_created": "created",
  "ib_fill_required": "Please fill in title and description",
  "ib_screenshot_added": "Screenshot added",
  "ib_dropzone": "Drag & drop or click to attach screenshots (max 5)",
  "ib_bugs": "Bugs",
  "ib_ideas_features": "Ideas & Feature Requests",
  "ib_votes": "Votes",
  "ib_priority": "Priority",
  "ib_assigned_to": "Assigned to",
  "ib_submitted_by": "Submitted by",
  "ib_details": "Details",
  "ib_manager_only": "Only Admins and Sales Managers can change status, priority and assignment.",
  "ib_move_to_roadmap": "Move to roadmap",
  "ib_on_roadmap": "On roadmap",
  "ib_moved_to_roadmap": "Moved to roadmap",
  "ib_already_on_roadmap": "Already on roadmap",

  "ib_jump_status": "Jump / revert status",
  "ib_linked_release": "Linked release",
  "ib_duplicate_of": "Duplicate of",
  "ib_attachments": "Attachments",
  "ib_max_files": "Maximum 5 attachments",
  "ib_dashboard_title": "Ideas & Bugs",
  "ib_open_bugs_severity": "Open bugs by severity",
  "ib_top_ideas": "Top voted open ideas",
  "ib_opened_30d": "Opened (30 days)",
  "ib_closed_30d": "Closed (30 days)",
  "roadmap": "Roadmap",
  "roadmap_desc": "What we are building next — vote to shape the priorities",
  "roadmap_submit": "Submit idea",
  "roadmap_submit_desc": "Suggest a new feature, improvement or integration for the roadmap.",
  "roadmap_title_field": "Title",
  "roadmap_business_value": "Business value",
  "roadmap_category": "Category",
  "roadmap_type": "Type",
  "roadmap_priority": "Priority",
  "roadmap_effort": "Effort",
  "roadmap_visibility": "Visibility",
  "roadmap_quarter": "Target quarter",
  "roadmap_kanban": "Board",
  "roadmap_timeline": "Timeline",
  "roadmap_list": "List",
  "roadmap_recently_released": "Recently released",
  "roadmap_unscheduled": "Not scheduled",
  "roadmap_votes_left": "Votes left this month",
  "roadmap_voted": "Vote recorded",
  "roadmap_submitted": "Idea submitted",
  "roadmap_digest": "Digest (PDF)",
  "roadmap_follow": "Follow",
  "roadmap_unfollow": "Following",
  "roadmap_reason": "Reason (public)",
  "roadmap_reason_ph": "Why is this declined or parked?",
  "roadmap_reason_required": "A written reason is required to decline or park an item",
  "roadmap_release_note": "Release note",
  "roadmap_release_version": "Release version",
  "roadmap_linked_ideas": "Linked Ideas & Bugs",
  "roadmap_vote_history": "Vote analytics",
  "roadmap_w_raw": "Raw votes",
  "roadmap_w_role": "Role-weighted",
  "roadmap_w_plant": "Plant-weighted",
  "roadmap_merge": "Merge into…",
  "roadmap_merge_desc": "Move all votes and followers into another item. This item will be marked as a duplicate.",
  "roadmap_merge_target": "Select target item",
  "roadmap_vote_budget": "Monthly vote budget per user",
  "roadmap_settings": "Roadmap",
  "roadmap_widget_title": "Roadmap",
  "roadmap_top_voted": "Top voted (not yet planned)",
  "roadmap_my_votes": "My votes",
  "roadmap_my_subs": "My submissions",
  "nav_group_orders": "Orders",
  "orders": "Orders",
  "order_inbox": "AI Order Intake",
  "article_master": "Article Master",
  "order_conditions": "Conditions",
  "open_confirmations": "Open Confirmations",
  "interface_monitor": "Interface Monitor",
  "ord_new": "New Order",
  "ord_new_desc": "Enter header data – add line items on the detail page afterwards.",
  "ord_order_number": "Order No.",
  "ord_customer": "Customer",
  "ord_customer_required": "Please select a customer",
  "ord_po": "PO Number",
  "ord_date": "Order Date",
  "ord_requested": "Requested Date",
  "ord_lines": "Line Items",
  "ord_total": "Total",
  "ord_source": "Source",
  "ord_erp": "ERP Number",
  "ord_description": "Description",
  "ord_stats_total": "Total Orders",
  "ord_stats_open_conf": "Open Confirmations",
  "ord_stats_production": "In Production",
  "ord_stats_month": "This Month",
  "ord_excel_export": "Excel Export",
  "ord_excel_import": "Excel Import",
  "ord_excel_template": "Import Template",
  "ord_import_ok": "orders imported ✓",
  "ord_page": "Page",
  "ord_created": "Order created",
  "ord_status_updated": "Status updated",
  "ord_advance": "Advance",
  "ord_cancel": "Cancel Order",
  "ord_cancel_reason": "Cancellation reason",
  "ord_reorder": "Reorder",
  "ord_reorder_of": "Reorder of",
  "ord_from_quote": "From quote",
  "ord_add_line": "Add line item",
  "ord_select_article": "Select article…",
  "ord_condition_applied": "Stored condition applied",
  "ord_confirm": "Confirm",
  "ord_confirmed": "confirmed",
  "ord_confirmed_at": "Confirmed at",
  "ord_no_open": "No open confirmations 🎉",
  "ord_openconf_desc": "Entered orders still awaiting an order confirmation – oldest first.",
  "quote_create_order": "Create Order",
  "art_new": "New Article",
  "art_name": "Article Name",
  "art_family": "Product Family",
  "art_material": "Material",
  "art_finishing": "Finishing",
  "art_size": "Size (mm)",
  "art_colors": "Colors",
  "art_winding": "Winding Direction",
  "art_core": "Core (mm)",
  "art_lpr": "Labels/Roll",
  "art_price": "Price/1000",
  "art_moq": "Min. Order Qty",
  "art_deactivated": "Article is used in orders – set to Inactive",
  "winding_outside": "Outside wound",
  "winding_inside": "Inside wound",
  "cond_new": "New Condition",
  "cond_type": "Type",
  "cond_type_price": "Special Price",
  "cond_type_discount": "Discount",
  "cond_type_payment": "Payment Terms",
  "cond_type_freight": "Freight",
  "cond_article": "Article",
  "cond_all_articles": "All articles",
  "cond_value": "Value",
  "cond_price": "Price/1000",
  "cond_discount": "Discount %",
  "cond_payment": "Payment Terms",
  "cond_min_qty": "Min. Qty",
  "cond_valid_from": "Valid from",
  "cond_valid_to": "Valid to",
  "inbox_phase2_title": "AI Order Intake arrives in Phase 2",
  "inbox_phase2_desc": "Unstructured orders (email, PDF) will be extracted by AI and presented as order proposals for review. This feature is planned as the next build phase.",
  "oi_page_desc": "Extract unstructured orders (email text, PDF, image) with AI — the order proposal is reviewed and edited before committing.",
  "oi_upload": "Upload file",
  "oi_paste": "Paste email text",
  "oi_paste_desc": "Paste an order email or free text — the AI detects customer, PO number, line items and dates.",
  "oi_paste_placeholder": "Dear Sir or Madam, we hereby order …",
  "oi_analyze": "Analyze with AI",
  "oi_analyzed_toast": "Analysis complete — please review the proposal",
  "oi_review": "Review order proposal",
  "oi_review_desc": "Review and edit the AI proposal. The order is only created after your confirmation.",
  "oi_commit": "Create order",
  "oi_committed_toast": "Order created:",
  "oi_discard": "Discard",
  "oi_discarded_toast": "Item discarded",
  "oi_reanalyze": "Re-analyze",
  "oi_reanalyzed": "Re-analyzed",
  "oi_confidence": "Confidence",
  "oi_no_checks": "No findings — plausibility checks passed",
  "oi_source": "Show source text",
  "oi_source_col": "Source",
  "oi_suggested_date": "Earliest date",
  "oi_promised": "Suggested delivery date (lead-time calculation)",
  "oi_unmatched": "Not in article master",
  "oi_suggestions": "Suggestions",
  "oi_has_errors": "Error findings present — commit is still possible once customer and quantities are set.",
  "oi_empty": "No items yet. Paste an email text or upload a file (PDF, EML, image) — the AI creates an order proposal.",
  "oi_stats_open": "Open (analyzed)",
  "oi_stats_committed": "Committed",
  "oi_stats_discarded": "Discarded",
  "oi_stats_error": "Errors",
  "oi_status_new": "New",
  "oi_status_analyzed": "Analyzed",
  "oi_status_committed": "Committed",
  "oi_status_discarded": "Discarded",
  "oi_status_error": "Error",
  "oi_open_order": "Open order:",
  "oi_error_generic": "Analysis failed — please try again.",
  "monitor_phase3_title": "Interface Monitor arrives in Phase 3",
  "monitor_phase3_desc": "The simulated ERP transmission (outbox, retries, error cases) will be monitored here. Until then, Excel import/export is available as the EDI alternative.",
  "ord_confirmation": "Order confirmation",
  "ord_ab_pdf": "Confirmation PDF",
  "ord_send_ab": "Send confirmation by e-mail",
  "ord_ab_preview": "Preview PDF",
  "ord_ab_last_sent": "Confirmation last sent to",
  "ord_custom_recipient": "Other e-mail address…",
  "ord_ab_msg": "Dear Sir or Madam,\n\nPlease find attached the order confirmation {num}.\n\nKind regards\n{user}",
  "acct_orders_recent": "Latest 50 orders",
  "sample_orders": "Sample orders",
  "nav_group_administration": "Administration",
  "view": "View",
  "enabled": "Enabled",
  "search": "Search",
  "first_name": "First name",
  "last_name": "Last name",
  "address": "Address",
  "see_margins": "Margins visible",
  "require_mfa": "MFA required",
  "my_profile": "My profile",
  "iam_dashboard": "Administration overview",
  "iam_dashboard_sub": "Users, roles, plants and security in one place",
  "iam_users": "Users",
  "iam_roles": "Roles & permissions",
  "iam_org": "Organization & plants",
  "iam_auth": "Login & security",
  "iam_audit": "Audit log",
  "iam_total_users": "Total users",
  "iam_active_30d": "Active (30 days)",
  "iam_pending_invites": "Pending invitations",
  "iam_pending_scope": "Pending scope assignment",
  "iam_pending_scope_badge": "scope pending",
  "iam_failed_logins": "Failed logins (7 days)",
  "iam_reassign_open": "Open handovers",
  "iam_plants": "Plants",
  "iam_roles_count": "Roles",
  "iam_sso_users": "SSO users",
  "iam_invite_user": "Invite user",
  "iam_invite_single": "Single",
  "iam_bulk_invite": "CSV bulk invite",
  "iam_invite_help": "Choose role and scope first, then send the invitation (valid 7 days).",
  "iam_bulk_help": "Columns: email;first_name;last_name;role;plants;segments \u2013 plants as plant code (e.g. HAM;KAS).",
  "iam_csv_template": "Template",
  "iam_validate": "Validate",
  "iam_import_invite": "Import & invite",
  "iam_send_invite": "Send invitation",
  "iam_invite_sent": "Invitation sent",
  "iam_search_users": "Name, email, department \u2026",
  "iam_save_view": "Save view",
  "iam_rename_view": "Rename view",
  "iam_delete_view_confirm": "Delete this saved view?",
  "iam_view_exists": "A view with this name already exists",
  "iam_view_update": "Overwrite with current filters",
  "iam_view_updated": "View updated",
  "iam_export_csv": "Export CSV",
  "iam_selected": "selected",
  "iam_assign_plants": "Assign plants",
  "iam_assign_segments": "Assign segments",
  "iam_change_role": "Change role",
  "iam_suspend": "Suspend",
  "iam_reactivate": "Reactivate",
  "iam_deactivate": "Deactivate",
  "iam_resend_invite": "Resend invitation",
  "iam_status_active": "Active",
  "iam_status_invited": "Invited",
  "iam_status_suspended": "Suspended",
  "iam_status_deactivated": "Deactivated",
  "iam_status_inactive": "Inactive",
  "iam_last_login": "Last login",
  "iam_auth_method": "Auth method",
  "iam_no_users": "No users found",
  "iam_bulk_dialog_help": "The selection is applied to all marked users.",
  "iam_tab_profile": "Profile",
  "iam_tab_permissions": "Role & permissions",
  "iam_tab_scope": "Scope",
  "iam_tab_activity": "Activity",
  "iam_tab_sessions": "Sessions",
  "iam_resolved_perms": "Resolved permissions \u2013 this user can:",
  "iam_effective_plants": "Effective plants",
  "iam_account_count": "Visible customers",
  "iam_revoke": "Revoke",
  "iam_sessions_none": "No sessions",
  "iam_activity_none": "No activity",
  "iam_owned_accounts": "Owned customers",
  "iam_successor_required": "Successor required",
  "iam_choose_successor": "Choose successor",
  "iam_gdpr_export": "GDPR export",
  "iam_anonymize": "Anonymize",
  "iam_disable_mfa": "Reset MFA",
  "iam_mfa_enabled": "MFA active",
  "iam_job_title": "Job title",
  "iam_department": "Department",
  "iam_manager": "Reports to",
  "iam_phone": "Phone",
  "iam_language": "Language",
  "iam_compliance_help": "GDPR: data export on request, anonymization after the retention period.",
  "iam_clone_role": "Clone role",
  "iam_new_role": "New role",
  "iam_system_role": "System role",
  "iam_affected_users": "affected users",
  "iam_matrix": "Permission matrix",
  "iam_matrix_help": "Modules as rows, actions as columns. Sensitive permissions are flagged.",
  "iam_clone_help": "System roles are immutable \u2013 clone and adjust the copy.",
  "iam_unassigned_view": "Unassigned customers",
  "iam_sensitive_confirm": "This permission is sensitive. Grant it?",
  "iam_sensitive_title": "Sensitive permission",
  "iam_grant": "Grant",
  "iam_role_saved": "Role saved",
  "iam_role_immutable": "System roles are immutable (view only).",
  "iam_description": "Description",
  "iam_roles_sub": "System roles, custom roles and permission matrix",
  "act_view": "View",
  "act_create": "Create",
  "act_edit": "Edit",
  "act_delete": "Delete",
  "act_approve": "Approve",
  "act_export": "Export",
  "act_configure": "Configure",
  "iam_organization": "Organization",
  "iam_legal_entities": "Legal entities",
  "iam_regions": "Regions",
  "iam_plant_code": "Plant code",
  "iam_country": "Country",
  "iam_city": "City",
  "iam_timezone": "Timezone",
  "iam_plant_manager": "Plant manager",
  "iam_vat_id": "VAT ID",
  "iam_default_language": "Default language",
  "iam_default_currency": "Default currency",
  "iam_org_sub": "Legal entities, regions and plants (50+ sites)",
  "iam_plant_help": "The plant code is unique and used for scope assignment and CSV import.",
  "iam_search_plants": "Search plant (code, name, city)",
  "iam_idps": "Identity providers",
  "iam_add_idp": "Add IdP",
  "iam_idp_type": "Type",
  "iam_domains": "Email domains",
  "iam_enforce_sso": "SSO required",
  "iam_jit": "Just-in-time provisioning",
  "iam_jit_role": "Default role on JIT",
  "iam_group_mappings": "Group mapping (IdP group \u2192 role)",
  "iam_no_idps": "No identity provider configured yet",
  "iam_idp_help": "Multiple IdPs can be active in parallel. The email domain decides where a login is routed.",
  "iam_enforce_warning": "With SSO enforcement, existing passwords for these domains are disabled.",
  "iam_security": "Security",
  "iam_pw_min": "Minimum password length",
  "iam_breach_check": "Breach-list check",
  "iam_idle_timeout": "Idle timeout (minutes)",
  "iam_session_lifetime": "Session lifetime (hours)",
  "iam_concurrent_sessions": "Concurrent sessions",
  "iam_remember_days": "Remember me (days)",
  "iam_mfa_roles": "MFA enforced for roles",
  "iam_invite_days": "Invitation valid (days)",
  "iam_login_audit": "Login audit",
  "iam_scim_enable": "Enable SCIM 2.0",
  "iam_scim_token": "SCIM token",
  "iam_rotate_token": "Rotate token",
  "iam_scim_help": "Register as SCIM endpoint in your IdP. Deprovisioned users land in the handover queue automatically.",
  "iam_auth_sub": "Identity providers, password rules, MFA, SCIM and login audit",
  "iam_audit_sub": "Immutable log of all permission and user changes",
  "iam_audit_filter_actor": "Actor",
  "iam_audit_event": "Event",
  "iam_audit_before": "Before",
  "iam_audit_after": "After",
  "iam_audit_export": "Export log",
  "iam_all_plants": "All plants",
  "iam_all_segments": "All segments",
  "iam_segments": "Segments",
  "iam_select_region": "Region",
  "iam_effective": "Effective",
  "iam_reassign": "Reassign customers",
  "iam_reassign_preview": "Preview",
  "iam_reassign_help": "Filter customers by segment, plant or current owner and hand them over in one step.",
  "iam_new_owner": "New owner",
  "iam_current_owner": "Current owner",
  "iam_affected_accounts": "affected customers",
  "iam_open_quotes": "open quotes",
  "iam_open_opps": "open opportunities",
  "iam_execute": "Execute",
  "iam_notify_owners": "Notify",
  "login_continue": "Continue",
  "login_back": "Back",
  "login_forgot": "Forgot password?",
  "login_reset_sent": "If the account exists, an email has been sent.",
  "login_mfa_title": "Enter the 6-digit code from your authenticator app.",
  "login_mfa_code": "MFA code",
  "login_verify": "Verify",
  "login_mfa_setup_hint": "MFA is required for your role \u2013 please set it up under \u201cMy profile\u201d.",
  "login_invite_welcome": "Welcome! Please set your password.",
  "login_set_password": "Set a new password",
  "login_pw_save": "Save password",
  "login_pw_set": "Password saved. Please sign in.",
  "login_pw_rules": "At least 12 characters, letters and digits, not a known breached password.",
  "prof_change_password": "Change password",
  "prof_current_pw": "Current password",
  "prof_new_pw": "New password",
  "prof_confirm_pw": "Repeat password",
  "prof_pw_mismatch": "Passwords do not match",
  "prof_saved": "Profile saved",
  "prof_mfa_setup": "Two-factor authentication",
  "prof_mfa_scan": "Store the secret in your authenticator app and enter the code:",
  "prof_mfa_activate": "Activate",
  "prof_sessions": "My sessions",
  "admin_moved_users": "User management moved to the new \u201cAdministration\u201d module: directory with server-side search, invitations, scope assignment, sessions and audit log.",
  "admin_moved_roles": "Permission profiles were migrated to roles. Roles, the permission matrix and custom roles are now managed under \u201cRoles & permissions\u201d.",
  "primary_segment": "Segment (primary)",
  "owning_plants": "Owning plants",
  "primary_plant": "Primary plant",
  "account_team": "Account team",
  "guide_manual": "Manual",
  "guide_search_ph": "Search a function…",
  "guide_update_btn": "Update manual",
  "guide_updating": "Updating…",
  "guide_last_updated": "Last updated",
  "guide_up_to_date": "Up to date",
  "guide_generating": "The manual is being generated — content will improve shortly.",
  "guide_sec_purpose": "What for?",
  "guide_sec_steps": "Step by step",
  "guide_sec_tips": "Tips",
  "guide_sec_roles": "Roles & permissions",
  "guide_select_prompt": "Select a topic on the left to read its guide.",
  "guide_no_results": "No matching function found.",
  "guide_ai_badge": "AI-written",
  "guide_all_topics": "All topics",
  "guide_whats_new": "What's new",
  "guide_new_badge": "New",
  "guide_whats_new_empty": "Nothing new yet.",
};
export default dict;
